import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const assessmentAmendment: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT}{id}`, 'get'> = data =>
  instance.get(`${API.ASSESSMENT_AMENDMENT}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const assessmentAmendmentCreate: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_AMENDMENT, data)

export const assessmentMarksGenerate: ApiFunc<`${typeof API.ASSESSMENT_MARKS_GENERATE}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_MARKS_GENERATE, {
    params: data,
    responseType: 'blob',
  })

export const assessmentZipUploads: ApiFunc<`${typeof API.ASSESSMENT_ZIP_UPLOADS}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_ZIP_UPLOADS, {
    params: data,
    responseType: 'blob',
  })

export const assessmentAmendmentDelete: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT}{id}`, 'delete'> = data =>
  instance.delete(`${API.ASSESSMENT_AMENDMENT}${'id' in data ? prop('id', data) : data?.name}}`)

export const assessmentAmendmentList: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_AMENDMENT, {
    params: data,
  })

export const assessmentAmendmentAll: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT_ALL}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_AMENDMENT_ALL, {
    params: data,
  })

export const assessmentAmendmentAllUpdated: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT_ALL_UPDATED}`, 'get'> = data =>
  instance.get(API.ASSESSMENT_AMENDMENT_ALL_UPDATED, {
    params: data,
  })

export const assessmentModeratorForm: ApiFunc<`${typeof API.ASSESSMENT_MODERATOR_FORM}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_MODERATOR_FORM, data, { responseType: 'blob' })

export const assessmentModeratorFormBulk: ApiFunc<`${typeof API.ASSESSMENT_MODERATOR_FORM_BULK}`, 'post'> = data =>
  instance.post(API.ASSESSMENT_MODERATOR_FORM_BULK, data, { responseType: 'blob' })

export const assessmentAmendmentPublish: ApiFunc<`${typeof API.ASSESSMENT_AMENDMENT_PUBLISH}`, 'put'> = data =>
  instance.put(API.ASSESSMENT_AMENDMENT_PUBLISH, data)

export const assessmentMarkChangeStatus: ApiFunc<`${typeof API.ASSESSMENT_MARK_CHANGE_STATUS}`, 'put'> = data =>
  instance.put(API.ASSESSMENT_MARK_CHANGE_STATUS, data)

export const assessmentCuMarkList: ApiFunc<`${typeof API.ASSESSMENT_CU_MARK_LIST}`, 'get'> = params =>
  instance.get(API.ASSESSMENT_CU_MARK_LIST, { params, responseType: 'blob' })
